import React, { useEffect } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";
import JurisdictionTab from "../components/JurisdictionTab";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { jurisdictionAuthorities_details, jurisdictionAuthorities_path } from "../redux/commonReducer";
import { getJurisdictionAuthorities } from "../redux/actionCreator";
import { API_BASE_IMAGE_URL } from "../constants/configuration";
import Head from "../constants/Head";
import { useNavigate, useParams } from "react-router-dom";

function Jurisdictions() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { page } = useParams();

  const [language, setLanguage] = useState("");
  const [tabActive, setTabActive] = useState(0);
  const [imageChange, setImageChange] = useState("");

  // DATAS
  const jurisdictionAuthorities = useSelector(jurisdictionAuthorities_details);
  const jurisdictionAuthoritiesPath = useSelector(jurisdictionAuthorities_path);

  useEffect(() => {
    dispatch(getJurisdictionAuthorities());
  }, []);

  useEffect(() => {
    const lang = localStorage.getItem("lang");
    setLanguage(lang);
    if (jurisdictionAuthorities) {
      navigate(
        `/${localStorage.getItem("lang") == "en" ? "en" : "ar"}/jurisdictions/${localStorage.getItem("lang") == "en"
          ? jurisdictionAuthorities[tabActive]?.title_slug_en
          : jurisdictionAuthorities[tabActive]?.title_slug_ar
        }`
      );
    }
  }, [localStorage.getItem("lang")]);

  useEffect(() => {
    if (jurisdictionAuthorities?.length) {
      if (page) {
        let tab = jurisdictionAuthorities?.find(
          (ele) => ele.title_slug_en == page || ele.title_slug_ar == page
        );
        let index = jurisdictionAuthorities.findIndex(
          (ele) => ele.title_slug_en == page || ele.title_slug_ar == page
        );
        if (tab == undefined) {
          navigate("/*")
        } else {
          setTabActive(index);
          setImageChange(tab?.banner_name);
        }
      } else {
        setImageChange(jurisdictionAuthorities[0]?.banner_name);
        navigate(
          `/${localStorage.getItem("lang") == "en" ? "en" : "ar"
          }/jurisdictions/${localStorage.getItem("lang") == "en"
            ? jurisdictionAuthorities[0]?.title_slug_en
            : jurisdictionAuthorities[0]?.title_slug_ar
          }`
        );
      }
    }
  }, [jurisdictionAuthorities]);

  const handleTabSelect = (key) => {
    setTabActive(key);
    setImageChange(jurisdictionAuthorities[key]?.banner_name);
    navigate(
      `/${localStorage.getItem("lang") == "en" ? "en" : "ar"}/jurisdictions/${localStorage.getItem("lang") == "en"
        ? jurisdictionAuthorities[key]?.title_slug_en
        : jurisdictionAuthorities[key]?.title_slug_ar
      }`
    );
  };

  return (
    <>
      <Head
        title={t("html_title.jurisdictions")}
        metatitle={t("html_title.jurisdictions")}
        metaDescription={t("html_title.jurisdictions")}
      />
      <Header />
      <section className="innerpage__header">
        <div className="container sm-pad-0">
          <div className="banner__image" style={{ minHeight: 330 }}>
            <img
              src={API_BASE_IMAGE_URL + jurisdictionAuthoritiesPath + "/" + imageChange}
              className="w-100"
              alt=""
            />
            <div className="contents">
              <div className="row">
                <div className="col-md-12 p-0">
                  <div className="header__title bottomPad">
                    <h2>{t("jurisdictions")}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="roles__assignments bg-default">
        <div className="container">
          <Tab.Container
            id="left-tabs-example"
            activeKey={tabActive}
            onSelect={handleTabSelect}
          >
            <Nav variant="pills" className="flex-column">
              <div className="jurisdiction assignment__tabItems">
                <Row className="nav-scroll">
                  {jurisdictionAuthorities?.map((ele, i) => {
                    return (
                      <Col md={3} sm={44} className="col-tab-3">
                        <Nav.Item>
                          <Nav.Link eventKey={`${i}`}>
                            <div className="assignment__tab">
                              <div className="icon">
                                <img
                                  src={
                                    API_BASE_IMAGE_URL +
                                    jurisdictionAuthoritiesPath + "/" +
                                    ele?.body_icon_name
                                  }
                                  alt=""
                                />
                              </div>
                              <div className="title">
                                <h5>
                                  {language == "en"
                                    ? ele?.sub_title_en
                                    : ele?.sub_title_ar}
                                </h5>
                                <h3>
                                  {language == "en"
                                    ? ele?.title_en
                                    : ele?.title_ar}
                                </h3>
                              </div>
                            </div>
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </Nav>
            <Tab.Content>
              {jurisdictionAuthorities?.map((ele, i) => {
                return (
                  <Tab.Pane eventKey={`${i}`}>
                    <JurisdictionTab data={ele} />
                  </Tab.Pane>
                );
              })}
            </Tab.Content>
          </Tab.Container>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Jurisdictions;
